import { TFunction } from 'i18next'
import React, { PropsWithChildren } from 'react'
import { ResourceType } from '../../../@types/i18n'
import AppBar from '../../../components/layout/AppBar'
import { ModalWrapperProps } from '../ModalWrapper'

interface ModalLayoutProps extends ModalWrapperProps {
	t?: TFunction<'modals', undefined>
	modalOnTop?: keyof ResourceType['modals']
}

const ModalLayout = ({
	appBarOptions,
	modalOnTop,
	t,
	children,
}: PropsWithChildren<ModalLayoutProps>) => {
	return (
		<>
			<AppBar
				label={appBarOptions?.label ?? (modalOnTop && t ? t(modalOnTop) : '')}
				isModal
				{...appBarOptions}
			/>
			<div
				id={modalOnTop?.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}
				className='layout-sm pt-0'
			>
				{children}
			</div>
		</>
	)
}

export default ModalLayout
